import type { ReactNode } from "react";
import s from "./ui.module.css";

export function Leer({ titel, children }: { titel: string; children?: ReactNode }) {
  return (
    <div className={s.leer}>
      <strong>{titel}</strong>
      {children}
    </div>
  );
}

export function Meldung({ fehler, children }: { fehler?: boolean; children: ReactNode }) {
  return (
    <div className={[s.meldung, fehler && s.meldungFehler].filter(Boolean).join(" ")} role={fehler ? "alert" : "status"}>
      {children}
    </div>
  );
}
